import React from 'react';
import '../../styles/DeleteConfirmModal.css';

export default function DeleteConfirmModal({ patientName, onCancel, onConfirm }) {
  return (
    <div className="dcm__overlay">
      <div className="dcm__modal-container">

        <div className="dcm__bg" />
        <div className="dcm__bg-tint" />

        <div className="dcm__content">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h6 className="fw-bold mb-0 dcm__title">Delete Confirmation</h6>
            <button className="dcm__close-btn" onClick={onCancel} aria-label="Close">X</button>
          </div>

          <p className="text-center mb-4 dcm__message">
            Are you sure delete &ldquo;<strong>{patientName}</strong>&rdquo;
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button className="btn dcm__btn-cancel px-4" onClick={onCancel}>Cancel</button>
            <button className="btn dcm__btn-delete px-4" onClick={onConfirm}>Delete</button>
          </div>
        </div>

      </div>
    </div>
  );
}